import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';
import { SepaMandate } from '../../models/sepa-mandates';
import { CustomerDocumentsService } from '../../services/customer-documents/customer-documents.service';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';
import { SepaMandatesListConfigService } from '../../services/sepa-mandates-list-config/sepa-mandates-list-config.service';
import { SepaMandatesService } from '../../services/sepa-mandates/sepa-mandates.service';

@Component({
  selector: 'lib-sepa-mandates-list',
  standalone: false,
  templateUrl: './sepa-mandates-list.component.html',
  styleUrl: './sepa-mandates-list.component.scss'
})
export class SepaMandatesListComponent {
  public sepaMandatesListConfigService = inject(SepaMandatesListConfigService);
  public sepaMandatesService = inject(SepaMandatesService);
  public gungModalService = inject(GungModalService);
  protected customerDocumentsService = inject(CustomerDocumentsService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);

  createNewMandate(): void {
    this.gungModalService
      .openCreateNewMandateModal()
      .then(({ mandate, file }: { mandate: SepaMandate; file: File | null }) => {
        this.sepaMandatesService.saveSepaMandate(mandate).subscribe({
          next: savedMandate => {
            if (file) {
              this.customerDocumentsService.uploadDocumentWithRelation(file, savedMandate.id, 'sepa-direct-debit_mandate');
            }
          },
          error: err => {
            const message = err?.error?.message || this.translateService.instant('ERROR_SAVING_MANDATE');
            this.gungNotificationService.notify(message, null, 'danger');
          }
        });
      })
      .catch(() => {});
  }
}
